import React from "react";
import { useParams } from "react-router";
import Container from "react-bootstrap/Container";

import Query from "../../components/Query";
import CATEGORY_ARTICLES_QUERY from "../../queries/category";

// import {Helmet} from "react-helmet-async";

import Header from "../../components/Header/category";
import Content from "../../components/Content/category";
import FAQ from "../../components/Faq";
import InfoBlock from "../../components/Content/infoblock";
import AditionalBlock from "../../components/Content/aditional";
import AdvantagesSection from "../../components/Content/Categories/advantages";
import CheckListSection from "../../components/Content/Categories/checklist_block";
import OurSchoolsBlock from "../../components/Content/our_schools";
import LearningStructure from "../../components/Content/Categories/learning_structure";

const Category = () => {
  let { slug } = useParams();

  return (
    <Query query={CATEGORY_ARTICLES_QUERY} slug={slug}>
      {({ data: { categories } }) => {
        if (categories.data.length) {
          const category = categories.data[0].attributes;

          return (
            <>
              <header className="layout layout__small layout__bg layout__bg_primary position-relative overflow-hidden">
                <Container fluid>
                  <Header props={category.header} newform={true}></Header>
                </Container>
              </header>
              <main className="layout layout__main">
                {category.slug === "erste-hilfe" && category.promo && (
                  <AditionalBlock aditional={category.promo} newform={false} />
                )}

                <section
                  className={`layout__color_primary position-relative ${
                    !category.infoblock ? "pb-0" : ""
                  }`}
                >
                  <Container fluid className="layout__main">
                    <Content
                      obj={category.catinfo}
                      catname={category.header.categoryname}
                    ></Content>
                  </Container>
                </section>

                {category.infoblock && (
                  <section className="layout layout__bg layout__bg_primary">
                    <InfoBlock element={category.infoblock} />
                  </section>
                )}

                {category.ourSchools && <OurSchoolsBlock />}

                {category.advantages && (
                  <AdvantagesSection element={category.advantages} />
                )}

                {category.learning_structure && (
                  <LearningStructure element={category.learning_structure} />
                )}

                {category.checklist && (
                  <section className="layout layout__bg layout__bg_primary">
                    <CheckListSection element={category.checklist} />
                  </section>
                )}

                <section className="layout__color_primary">
                  <Container fluid>
                    <h2 data-aos="fade-up" className="">
                      FAQ - {category.faq.title}
                    </h2>
                    <FAQ elements={category.faq.qa} newform={true} />
                  </Container>
                </section>
              </main>
            </>
          );
        }
      }}
    </Query>
  );
};

export default Category;
